
import { PageRequest } from "@/store/shared/entity";
import CreateSender from "./component/create-sender.vue";
import EditSender from "./component/edit-sender.vue";
import uploadImage from "@/components/form/hi-upload-file/components/upload.vue";

import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins, PageResultListMixins } from "@/lib";

class PageSenderRequest extends PageRequest {
  name: string;
}

@Component({
  name: "sender.list", //设置页面对应route的名字，以便keepalive进行缓存
  components: { CreateSender, EditSender },
})
export default class Sender extends Mixins(PageResultBaseMixins, PageResultModalMixins, PageResultListMixins) {
  /**
   * section buttons
   */
  sectionButtons = { ...this.addBtn() };

  /**
   * search-page bind data
   */
  data: any = {
    model: new PageSenderRequest(),
    queryAction: "system/sender/getAll",
    isAutoQuery: true,
    cols: this.columns,
  };

  /**
   * table columns
   */
  get columns() {
    return [
      {
        title: this.L("app.Sender.NameAndEn"),
        key: "name",
        tooltip: true,
        width: "400px",
        render: (h: any, params: any) => {
          return h("span", [h("span", `${params.row.name}`), h("br"), h("span", `${params.row.nameEn}`)]);
        },
      },
      // { title: this.L("app.Sender.NameEn"), key: "nameEn", tooltip: true },
      { title: this.L("app.Sender.TaxIndentifierNumber"), key: "taxIndentifierNumber", width: "300px", tooltip: true },
      {
        title: this.L("app.Sender.InvoiceSeal"),
        width: "150px",
        render: (h: any, params: any) => {
          return h(uploadImage, {
            props: {
              type: "image",
              value: [{ fileId: params.row.invoiceSeal[0].fileId }],
              isViewOnly: true,
            },
          });
        },
      },
      {
        title: this.L("app.Sender.SealPic"),
        width: "150px",
        render: (h: any, params: any) => {
          return h(uploadImage, {
            props: {
              type: "image",
              value: [{ fileId: params.row.attachment }],
              isViewOnly: true,
            },
          });
        },
      },
      

      { title: this.L("app.Sender.Address"), key: "address", tooltip: true },

      this.$util.render.actions(this.colButtons, ()=>{return {fixed: "right"}})
    ];
  }

  colButtonCheck = (row) => {
    return !row.isStatic;
  };

  /**
   * table 操作列按钮
   */
  get colButtons(): ActionButtonConfig[] {
    return [this.colEditBtnM((row) => this.colButtonCheck(row)), this.colDeleteBtn((row) => this.colButtonCheck(row))];
  }

  /**
   * reset 回调
   */
  reset() {
    this.data.model = new PageSenderRequest();
  }
}
